import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "pc-container"
};
var _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['app-root', {
      'pc-wrapper': $setup.isPcOuter && !$setup.isStandaloneGuide
    }])
  }, [$setup.isPcOuter && !$setup.isStandaloneGuide ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("iframe", {
    class: "pc-iframe",
    src: $setup.iframeSrc,
    frameborder: "0"
  }, null, 8, _hoisted_2)])) : (_openBlock(), _createBlock(_component_router_view, {
    key: 1
  }))], 2);
}